function Footer() {

    return(
        <footer className="footer">Copyright 2025 Gabrielle Burgard</footer>
    )


}

export default Footer;
